import { useState, useEffect, useRef, Fragment } from 'react';
import { 
  Moon, Sun, Hotel, Home, MapPin, Calendar, Users, Utensils, Dumbbell, Spa, 
  ConciergeBell, Star, ChevronRight, Search, Menu, X, Heart, Share2, Phone, 
  MessageSquare, Video, ArrowLeft, ArrowRight, Globe, CreditCard, Wifi, 
  Droplets, Snowflake, Tv, Coffee, Wine, ShoppingBag, Bell, User, Key, 
  Clock, ShieldCheck, Gift, TrendingUp, Award, Camera, Map,
Mail,
  Banknote,
  Bitcoin,
  Check,
 
} from 'lucide-react';
import InteractiveHotelMap from './InteractiveHotelMap';
import BookingModal from './Booking';
import ContactPopup from './contact';



const HotelSystem = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [showVirtualTour, setShowVirtualTour] = useState(false);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);
  const carouselRef = useRef(null);
  const adRef = useRef(null);
  const [showBookingInterface, setShowBookingInterface] = useState(false);

  // Auto-rotate ads
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAdIndex((prev) => (prev + 1) % ads.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  // Dark mode toggle
  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]);

  // Sample data
  const hostels = [
    // Uganda Hostels
    {
        id: 1,
        name: "Bushpig Backpackers Hostel",
        latitude: 0.3136,
        longitude: 32.5811,
        city: "Kampala",
        country: "Uganda",
        price: 18,
        rating: 4.5,
        type: 'standard',
        amenities: ['wifi', 'restaurant', 'bar', 'tour', 'luggage'],
        images: [
        "https://www.isdb.org/sites/default/files/styles/opengraph/public/uganda%202.png?itok=dzpNpK7h",
        "https://www.isdb.org/sites/default/files/styles/opengraph/public/uganda%202.png?itok=dzpNpK7h"
        ],
        description: "Vibrant social hostel in the heart of Kampala with nightly events and a rooftop bar overlooking the city. Perfect base for exploring Uganda.",
        reviews: 287,
        distance: "1.2 km from city center",
        policies: {
        cancellation: "Free cancellation 48 hours prior",
        checkIn: "2:00 PM",
        checkOut: "10:30 AM"
        }
    },
    {
        id: 2,
        name: "NANA hostel",
        latitude: 0.4244,
        longitude: 33.2026,
        city: "Jinja",
        country: "Uganda",
        price: 22,
        rating: 4.8,
        type: 'eco',
        amenities: ['wifi', 'restaurant', 'pool', 'tour', 'laundry'],
        images: [
        "https://www.monitor.co.ug/resource/image/1551160/portrait_ratio1x1/1600/1600/39936478151c52b7db14e1dc8984822d/Sv/life01pix.jpg",
        "https://www.monitor.co.ug/resource/image/1551160/portrait_ratio1x1/1600/1600/39936478151c52b7db14e1dc8984822d/Sv/life01pix.jpg"
        ],
        description: "Eco-friendly hostel on the banks of the Nile with adventure packages including white-water rafting and bungee jumping.",
        reviews: 194,
        distance: "Riverfront property"
    },
    {
        id: 3,
        name: "Muhika Hostel",
        latitude: 0.0644,
        longitude: 32.4465,
        city: "Kampala",
        country: "Uganda",
        price: 25,
        rating: 4.3,
        type: 'standard',
        amenities: ['wifi', 'restaurant', 'luggage', 'security', 'breakfast'],
        images: [
        "https://i1.sndcdn.com/artworks-000118772753-c3oz0p-t500x500.jpg",
        "https://i1.sndcdn.com/artworks-000118772753-c3oz0p-t500x500.jpg"
        ],
        description: "Convenient budget accommodation just 5 minutes from Entebbe International Airport with 24/7 shuttle service.",
        reviews: 156,
        distance: "5 min from airport"
    },
    {
        id: 4,
        name: "Queen Elizabeth Bush Camp",
        latitude: -0.1826,
        longitude: 30.0039,
        city: "Kasese",
        country: "Uganda",
        price: 30,
        rating: 4.7,
        type: 'eco',
        amenities: ['restaurant', 'tour', 'bar', 'breakfast'],
        images: [
        "https://www.riverlodge.co.za/cdn/shop/products/IMG_0030.JPG?v=1527758690",
        "https://www.riverlodge.co.za/cdn/shop/products/IMG_0030.JPG?v=1527758690"
        ],
        description: "Wilderness hostel offering budget safari experiences with stunning views of the Rwenzori Mountains.",
        reviews: 132,
        distance: "Adjacent to national park"
    },

    // Africa
    {
        id: 5,
        name: "Cape Town Backpackers",
        latitude: -33.9249,
        longitude: 18.4241,
        city: "Cape Town",
        country: "South Africa",
        price: 20,
        rating: 4.9,
        type: 'boutique',
        amenities: ['wifi', 'bar', 'pool', 'tour', 'laundry'],
        images: [
        "https://media.nomadicmatt.com/2023/capetownhostel3.jpeg",
        "https://media.nomadicmatt.com/2023/capetownhostel3.jpeg"
        ],
        description: "Designer hostel in Sea Point with rooftop pool and daily tours to Table Mountain.",
        reviews: 423,
        distance: "Sea Point district"
    },
    {
        id: 6,
        name: "Marrakech Riad Hostel",
        latitude: 31.6295,
        longitude: -7.9811,
        city: "Marrakech",
        country: "Morocco",
        price: 15,
        rating: 4.6,
        type: 'boutique',
        amenities: ['wifi', 'restaurant', 'pool', 'tour'],
        images: [
        "https://pix10.agoda.net/hotelImages/493794/0/ed18238b64c879cf74218728b9822a50.jpeg?s=414x232",
        "https://pix10.agoda.net/hotelImages/493794/0/ed18238b64c879cf74218728b9822a50.jpeg?s=414x232"
        ],
        description: "Authentic Moroccan riad with courtyard pool in the Medina. Evening mint tea on the terrace.",
        reviews: 387,
        distance: "Medina center"
    },

    // Europe
    {
        id: 7,
        name: "Berlin Hipster Hostel",
        latitude: 52.5200,
        longitude: 13.4050,
        city: "Berlin",
        country: "Germany",
        price: 28,
        rating: 4.4,
        type: 'party',
        amenities: ['wifi', 'bar', 'restaurant', 'tour', 'laundry'],
        images: [
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/df/a5/86/grand-hostel-berlin-urban.jpg?w=1200&h=-1&s=1",
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/df/a5/86/grand-hostel-berlin-urban.jpg?w=1200&h=-1&s=1e"
        ],
        description: "Legendary party hostel in Kreuzberg with underground club and rooftop cinema.",
        reviews: 512,
        distance: "Kreuzberg district"
    },
    {
        id: 8,
        name: "kabul hostel",
        latitude: 41.3851,
        longitude: 2.1734,
        city: "Barcelona",
        country: "Spain",
        price: 26,
        rating: 4.8,
        type: 'party',
        amenities: ['wifi', 'bar', 'pool', 'tour'],
        images: [
        "https://www.kabul.es/wp-content/uploads/2019/10/DSC04367.jpg",
        "https://www.kabul.es/wp-content/uploads/2019/10/DSC04367.jpg"
        ],
        description: "Beachfront party hostel with daily paella nights and pub crawls.",
        reviews: 476,
        distance: "50m from beach"
    },

    // Asia
    {
        id: 9,
        name: "Bangkok Social Hostel",
        latitude: 13.7563,
        longitude: 100.5018,
        city: "Bangkok",
        country: "Thailand",
        price: 12,
        rating: 4.7,
        type: 'standard',
        amenities: ['wifi', 'ac', 'restaurant', 'tour'],
        images: [
        "https://meet-up-hostel-bangkok.bangkokshotels.com/data/Pictures/OriginalPhoto/6358/635864/635864616/bangkok-meet-up-hostel-picture-1.JPEG",
        "https://www.global-gallivanting.com/wp-content/uploads/2017/05/the-yard-hostel-bangkok.png"
        ],
        description: "Lively social hostel near Khao San Road with daily street food tours.",
        reviews: 598,
        distance: "5 min walk to Khao San"
    },
    {
        id: 10,
        name: "Bali Eco Lodge",
        latitude: -8.3405,
        longitude: 115.0920,
        city: "Ubud",
        country: "Indonesia",
        price: 18,
        rating: 4.9,
        type: 'eco',
        amenities: ['wifi', 'restaurant', 'pool', 'tour', 'yoga'],
        images: [
        "https://a.hwstatic.com/image/upload/f_auto,q_auto,t_40/propertyimages/3/302036/jxvqzu63cs50kxxi2clz.jpg",
        "https://a.hwstatic.com/image/upload/f_auto,q_auto,t_40/propertyimages/3/302036/jxvqzu63cs50kxxi2clz.jpg"
        ],
        description: "Sustainable jungle hostel with daily yoga and organic farm-to-table meals.",
        reviews: 432,
        distance: "Ubud center"
    },

    // Americas
    {
        id: 11,
        name: "Rio Beach Hostel",
        latitude: -22.9068,
        longitude: -43.1729,
        city: "Rio de Janeiro",
        country: "Brazil",
        price: 22,
        rating: 4.6,
        type: 'party',
        amenities: ['wifi', 'bar', 'pool', 'tour'],
        images: [
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/19/ff/ca/3c/el-misti-ipanema.jpg?w=1200&h=-1&s=1",
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/19/ff/ca/3c/el-misti-ipanema.jpg?w=1200&h=-1&s=1"
        ],
        description: "Vibrant hostel steps from Copacabana with samba nights and caipirinha classes.",
        reviews: 387,
        distance: "Beachfront"
    },
    {
        id: 12,
        name: "New York Loft Hostel",
        latitude: 40.7128,
        longitude: -74.0060,
        city: "New York",
        country: "USA",
        price: 45,
        rating: 4.3,
        type: 'luxury',
        amenities: ['wifi', 'restaurant', 'rooftop', 'tour'],
        images: [
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/03/75/bc/a9/hostelling-international.jpg?w=1200&h=-1&s=1",
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/03/75/bc/a9/hostelling-international.jpg?w=1200&h=-1&s=1"
        ],
        description: "Industrial-chic loft-style hostel in Brooklyn with Manhattan skyline views.",
        reviews: 321,
        distance: "Williamsburg"
    },

    // More Uganda Hostels
    {
        id: 13,
        name: "Murchison Safari Camp",
        latitude: 2.1769,
        longitude: 31.6148,
        city: "Masindi",
        country: "Uganda",
        price: 35,
        rating: 4.6,
        type: 'eco',
        amenities: ['restaurant', 'bar', 'tour', 'breakfast'],
        images: [
        "https://www.hostelz.com/pics/slp/1121/Hostels-in-Rio-de-Janeiro-with-Private-Rooms.jpg",
        "https://www.hostelz.com/pics/slp/1121/Hostels-in-Rio-de-Janeiro-with-Private-Rooms.jpge"
        ],
        description: "Budget safari accommodation with guided game drives in Murchison Falls National Park.",
        reviews: 187,
        distance: "Park entrance 2km"
    },
    {
        id: 14,
        name: "Lake Bunyonyi Overlook",
        latitude: -1.2765,
        longitude: 29.9086,
        city: "Kabale",
        country: "Uganda",
        price: 28,
        rating: 4.9,
        type: 'boutique',
        amenities: ['wifi', 'restaurant', 'kayak', 'yoga'],
        images: [
        "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1",
        "https://images.unsplash.com/photo-1504150558240-0b4fd8946624"
        ],
        description: "Stunning lakeside hostel with island hopping tours and sunset yoga sessions.",
        reviews: 213,
        distance: "Lakeside property"
    },

    // More International Hostels
    {
        id: 15,
        name: "Sydney Harbour Hostel",
        latitude: -33.8688,
        longitude: 151.2093,
        city: "Sydney",
        country: "Australia",
        price: 32,
        rating: 4.7,
        type: 'boutique',
        amenities: ['wifi', 'restaurant', 'pool', 'tour'],
        images: [
        "https://tequilasunrisehostels.com/cdn/shop/files/TequilaSunriseSydneySm-7.jpg?v=1688617687",
        "https://tequilasunrisehostels.com/cdn/shop/files/TequilaSunriseSydneySm-7.jpg?v=1688617687"
        ],
        description: "Designer hostel in The Rocks with Opera House views and rooftop BBQs.",
        reviews: 354,
        distance: "Circular Quay 5min"
    },
    {
        id: 16,
        name: "Kyoto Zen House",
        latitude: 35.0116,
        longitude: 135.7681,
        city: "Kyoto",
        country: "Japan",
        price: 25,
        rating: 4.9,
        type: 'eco',
        amenities: ['wifi', 'restaurant', 'tour', 'onsen'],
        images: [
        "https://www.gotokyo.org/en/story/guide/a-guide-to-capsule-hotels-in-japan/images/main.webp",
        "https://www.gotokyo.org/en/story/guide/a-guide-to-capsule-hotels-in-japan/images/main.webp"
        ],
        description: "Traditional Japanese hostel with zen garden and tea ceremonies.",
        reviews: 298,
        distance: "Gion district"
    },
    {
        id: 17,
        name: "Lisbon Sunset Hostel",
        latitude: 38.7223,
        longitude: -9.1393,
        city: "Lisbon",
        country: "Portugal",
        price: 20,
        rating: 4.8,
        type: 'boutique',
        amenities: ['wifi', 'bar', 'rooftop', 'tour'],
        images: [
        "https://www.destinationhostels.com/wp-content/uploads/2021/07/LisbonDestinationHostel-1.jpg",
        "https://www.destinationhostels.com/wp-content/uploads/2021/07/LisbonDestinationHostel-1.jpg"
        ],
        description: "Charming hostel in Alfama with fado nights and stunning river views.",
        reviews: 412,
        distance: "Old town center"
    },
    {
        id: 18,
        name: "Prague Castle Hostel",
        latitude: 50.0755,
        longitude: 14.4378,
        city: "Prague",
        country: "Czech Republic",
        price: 18,
        rating: 4.5,
        type: 'standard',
        amenities: ['wifi', 'bar', 'tour', 'breakfast'],
        images: [
        "https://hostelgeeks.com/wp-content/uploads/2023/02/Czech-Inn-Prague-Dorm.jpg",
        "https://hostelgeeks.com/wp-content/uploads/2023/02/Czech-Inn-Prague-Dorm.jpg"
        ],
        description: "Historic hostel just below Prague Castle with medieval cellar bar.",
        reviews: 376,
        distance: "Charles Bridge 10min"
    },
    {
        id: 19,
        name: "Budapest Thermal Hostel",
        latitude: 47.4979,
        longitude: 19.0402,
        city: "Budapest",
        country: "Hungary",
        price: 16,
        rating: 4.7,
        type: 'boutique',
        amenities: ['wifi', 'spa', 'bar', 'tour'],
        images: [
        "https://mavericklodges.com/wp-content/uploads/2024/08/location-1.jpg",
        "https://mavericklodges.com/wp-content/uploads/2024/08/location-1.jpg"
        ],
        description: "Unique hostel with access to thermal baths and ruin pub crawls.",
        reviews: 342,
        distance: "City Park 5min"
    },
    {
        id: 20,
        name: "Lima Surf Hostel",
        latitude: -12.0464,
        longitude: -77.0428,
        city: "Lima",
        country: "Peru",
        price: 15,
        rating: 4.4,
        type: 'standard',
        amenities: ['wifi', 'restaurant', 'surf', 'tour'],
        images: [
        "https://images.trvl-media.com/lodging/45000000/45000000/44998700/44998684/0bc0fee2.jpg?impolicy=resizecrop&rw=575&rh=575&ra=fill",
        "https://images.trvl-media.com/lodging/45000000/45000000/44998700/44998684/0bc0fee2.jpg?impolicy=resizecrop&rw=575&rh=575&ra=fill5"
        ],
        description: "Beachfront hostel in Miraflores with surf lessons and ceviche nights.",
        reviews: 287,
        distance: "Cliffs overlooking Pacific"
    },
    {
        id: 21,
        name: "Zanzibar Beach House",
        latitude: -6.1659,
        longitude: 39.2026,
        city: "Zanzibar",
        country: "Tanzania",
        price: 28,
        rating: 4.9,
        type: 'luxury',
        amenities: ['wifi', 'restaurant', 'beach', 'diving'],
        images: [
        "https://www.udsm.ac.tz/sites/default/files/inline-images/Mabibo%20Hostels.jpg1",
        "https://www.udsm.ac.tz/sites/default/files/inline-images/Mabibo%20Hostels.jpg"
        ],
        description: "Boutique beach hostel with spice farm tours and dhow sailing trips.",
        reviews: 231,
        distance: "Beachfront"
    },
    {
        id: 22,
        name: "Hanoi Old Quarter Hostel",
        latitude: 21.0285,
        longitude: 105.8542,
        city: "Hanoi",
        country: "Vietnam",
        price: 10,
        rating: 4.6,
        type: 'standard',
        amenities: ['wifi', 'restaurant', 'tour', 'laundry'],
        images: [
        "https://media-cdn.tripadvisor.com/media/photo-s/0c/c7/cf/36/front-of-hotel.jpg",
        "https://media-cdn.tripadvisor.com/media/photo-s/0c/c7/cf/36/front-of-hotel.jpg"
        ],
        description: "Lively hostel in the heart of Hanoi with street food tours and motorbike rentals.",
        reviews: 498,
        distance: "Hoan Kiem Lake 5min"
    },
    {
        id: 23,
        name: "Istanbul Crossroads Hostel",
        latitude: 41.0082,
        longitude: 28.9784,
        city: "Istanbul",
        country: "Turkey",
        price: 18,
        rating: 4.7,
        type: 'boutique',
        amenities: ['wifi', 'rooftop', 'tour', 'hammam'],
        images: [
        "https://media.nomadicmatt.com/2022/istanbulhostels.jpeg",
        "https://media.nomadicmatt.com/2022/istanbulhostels.jpeg"
        ],
        description: "Stunning rooftop views of the Blue Mosque with authentic Turkish breakfast.",
        reviews: 387,
        distance: "Sultanahmet district"
    },
    {
        id: 24,
        name: "Reykjavik Northern Lights Hostel",
        latitude: 64.1265,
        longitude: -21.8174,
        city: "Reykjavik",
        country: "Iceland",
        price: 42,
        rating: 4.8,
        type: 'luxury',
        amenities: ['wifi', 'hot tub', 'tour', 'laundry'],
        images: [
        "https://galaxypodhostel.is/images/2018/01/22/732-copy.jpg",
        "https://galaxypodhostel.is/images/2018/01/22/732-copy.jpg"
        ],
        description: "Geothermal heated hostel with aurora wake-up service and glacier tours.",
        reviews: 276,
        distance: "Downtown Reykjavik"
    },
    {
        id: 25,
        name: "Fort Portal Garden Hostel",
        latitude: 0.6933,
        longitude: 30.2756,
        city: "Fort Portal",
        country: "Uganda",
        price: 22,
        rating: 4.5,
        type: 'eco',
        amenities: ['wifi', 'garden', 'tour', 'breakfast'],
        images: [
        "https://www.ugabox.com/images/business/directory/hostels/akamwesi-hostel/Akamwesi-Hostel-Nakawa-Aka-Hostel-Makerere-University-Business-School-MUBS-Victoria-University-Student-Hostel-Kampala-Uganda-01.JPG",
        "https://www.ugabox.com/images/business/directory/hostels/akamwesi-hostel/Akamwesi-Hostel-Nakawa-Aka-Hostel-Makerere-University-Business-School-MUBS-Victoria-University-Student-Hostel-Kampala-Uganda-01.JPG"
        ],
        description: "Tranquil garden hostel with crater lake tours and chimpanzee trekking packages.",
        reviews: 154,
        distance: "Town center 1km"
    }
    ];

    const ads = [
    {
      id: 1,
      title: "Backpacker's Paradise Deal",
      content: "Stay 5 nights at any Banana Hostel location worldwide and get 2 nights free. Plus free city tour included.",
      cta: "Book Adventure",
      bgImage: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      hostels: [
        "Banana Hostel Bangkok (Thailand)",
        "Banana Hostel Berlin (Germany)",
        "Banana Hostel Rio (Brazil)"
      ]
    },
    {
      id: 2,
      title: "New Hostel Alert: Safari Lodge",
      content: "Be among the first to stay at Uganda's new Jungle Junction Hostel - 20% off for bookings this month!",
      cta: "Explore Offer",
      bgImage: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      hostels: [
        "Jungle Junction Hostel (Uganda)"
      ]
    },
    {
      id: 3,
      title: "European Hostel Pass",
      content: "Access to 15+ top-rated hostels across Europe including The Flying Pig (Amsterdam) and Generator (London).",
      cta: "Get Pass",
      bgImage: "https://images.unsplash.com/photo-1499678329028-101435549a4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      hostels: [
        "The Flying Pig (Netherlands)",
        "Generator Hostel (UK)",
        "St. Christopher's Inn (France)",
        "Wombats City Hostel (Germany)"
      ]
    },
    {
      id: 4,
      title: "Beach Hostel Special",
      content: "25% off at all Surf & Stay hostels in Australia, Indonesia and Costa Rica. Includes free surfboard rental!",
      cta: "Ride Waves",
      bgImage: "https://images.unsplash.com/photo-1504150558240-0b4fd8946624?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      hostels: [
        "Surf & Stay Bali (Indonesia)",
        "Surf & Stay Byron Bay (Australia)",
        "Surf & Stay Tamarindo (Costa Rica)"
      ]
    },
    {
      id: 5,
      title: "Mountain Hostel Week",
      content: "7 nights for price of 5 at alpine hostels including Mountain Lounge (Switzerland) and The Snowflake (Japan).",
      cta: "Book Retreat",
      bgImage: "https://media-cdn.tripadvisor.com/media/photo-s/0b/4d/24/24/night-view.jpg",
      hostels: [
        "Mountain Lounge Hostel (Switzerland)",
        "The Snowflake Lodge (Japan)",
        "Andes Basecamp Hostel (Chile)"
      ]
    },
    {
      id: 6,
      title: "City Break Flash Sale",
      content: "Last-minute deals at urban hostels - from $12/night in Bangkok, Lisbon and Marrakech!",
      cta: "Grab Deal",
      bgImage: "https://www.hostelz.com/pics/imported/listings/thumbnails/47/5432947.jpghttps://www.hostelworld.com/blog/wp-content/uploads/2018/10/UK-best-hostels-2018-Palmers-Lodge-London.jpg",
      hostels: [
        "Bangkok Backpackers (Thailand)",
        "Lisbon Downtown Hostel (Portugal)",
        "Marrakech Riad Hostel (Morocco)"
      ]
    },
    {
      id: 7,
      title: "African Adventure Package",
      content: "Combined stays at Kampala Backpackers (Uganda), Zanzibar Beach House (Tanzania) and Cape Town Views (SA).",
      cta: "Plan Safari",
      bgImage: "https://www.hostelworld.com/blog/wp-content/uploads/2016/10/Capture-1.jpg",
      hostels: [
        "Kampala Backpackers (Uganda)",
        "Zanzibar Beach House (Tanzania)",
        "Cape Town Views Hostel (South Africa)"
      ]
    },
    {
      id: 8,
      title: "Winter Hostel Specials",
      content: "Cozy up in Nordic hostels - thermal baths in Reykjavik (Iceland) and northern lights viewing in Tromsø (Norway).",
      cta: "Stay Warm",
      bgImage: "https://images.trvl-media.com/lodging/11000000/10060000/10052800/10052731/432f937c.jpg?impolicy=fcrop&w=357&h=201&p=1&q=medium",
      hostels: [
        "Reykjavik Lights Hostel (Iceland)",
        "Arctic Circle Hostel (Norway)",
        "Snow Castle Hostel (Finland)"
      ]
    }
  ];

  const uniqueFeatures = [
    {
      icon: <User className="w-8 h-8" />,
      title: "Personal Travel Designer",
      description: "Your dedicated expert crafts every detail of your stay"
    },
    {
      icon: <Key className="w-8 h-8" />,
      title: "Keyless Entry",
      description: "Seamless access via our mobile app"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Flexible Timing",
      description: "Custom check-in/out based on your schedule"
    },
    {
      icon: <ShieldCheck className="w-8 h-8" />,
      title: "VIP Security",
      description: "Discreet protection for high-profile guests"
    }
  ];

  const toggleFavorite = (hotelId) => {
    if (favorites.includes(hotelId)) {
      setFavorites(favorites.filter(id => id !== hotelId));
    } else {
      setFavorites([...favorites, hotelId]);
    }
  };

  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const { scrollLeft, clientWidth } = carouselRef.current;
      const scrollTo = direction === 'left' 
        ? scrollLeft - clientWidth 
        : scrollLeft + clientWidth;
      carouselRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  if (selectedHotel) {
    return <HotelDetail 
      hotel={selectedHotel} 
      onBack={() => setSelectedHotel(null)} 
      darkMode={darkMode} 
      isFavorite={favorites.includes(selectedHotel.id)}
      onToggleFavorite={toggleFavorite}
      onVirtualTour={() => setShowVirtualTour(true)}
    />;
  }

   
  if (showVirtualTour) {
    return (
      <div className={`fixed inset-0 z-50 ${darkMode ? 'bg-gray-900' : 'bg-white'} flex flex-col`}>
        <div className={`p-4 flex justify-between items-center ${darkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
          <button 
            onClick={() => setShowVirtualTour(false)}
            className="flex items-center text-amber-500"
          >
            <ArrowLeft className="h-5 w-5 mr-1" />
            Back to hotel
          </button>
          <h3 className="text-lg font-medium">Virtual Tour: {selectedHotel.name}</h3>
          <div className="w-6"></div> {/* Spacer for alignment */}
        </div>
        <div className="flex-1 relative">
          <iframe 
            src={selectedHotel.virtualTour}
            className="w-full h-full"
            frameBorder="0"
            allow="fullscreen"
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen transition-colors duration-300 ${darkMode ? 'dark bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'}`}>
      {/* Navigation */}
      <nav className={`fixed w-full z-50 ${darkMode ? 'bg-gray-800/90 backdrop-blur' : 'bg-white/90 backdrop-blur'} shadow-sm`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            <div className="flex items-center">
              <Hotel className="h-8 w-8 text-amber-500" />
              <span className="ml-2 text-xl font-serif font-bold">Al-Saray<span className="text-amber-500">HMS</span></span>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => setActiveSection('home')}
                className={`${activeSection === 'home' ? 'text-amber-500 border-b-2 border-amber-500' : 'hover:text-amber-400'} px-1 py-2 text-sm font-medium transition-colors`}
              >
                Home
              </button>
              <button 
                onClick={() => setActiveSection('hotels')}
                className={`${activeSection === 'hotels' ? 'text-amber-500 border-b-2 border-amber-500' : 'hover:text-amber-400'} px-1 py-2 text-sm font-medium transition-colors`}
              >
                Hostels
              </button>
              <button 
                onClick={() => setActiveSection('guesthouses')}
                className={`${activeSection === 'guesthouses' ? 'text-amber-500 border-b-2 border-amber-500' : 'hover:text-amber-400'} px-1 py-2 text-sm font-medium transition-colors`}
              >
                Guest Houses
              </button>
              <button 
                onClick={() => setActiveSection('experiences')}
                className={`${activeSection === 'experiences' ? 'text-amber-500 border-b-2 border-amber-500' : 'hover:text-amber-400'} px-1 py-2 text-sm font-medium transition-colors`}
              >
                Experiences
              </button>
              <button 
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                {darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
              </button>
              <button 
                onClick={() => setSelectedHotel()}
              className="bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-medium transition-colors shadow-md">
                Book Now
              </button>
            </div>
            
            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button 
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 mr-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                {darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
              </button>
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
              </button>
            </div>
          </div>
        </div>
        
        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className={`md:hidden ${darkMode ? 'bg-gray-800' : 'bg-white'} pb-3 px-4`}>
            <div className="flex flex-col space-y-2">
              <button 
                onClick={() => {setActiveSection('home'); setMobileMenuOpen(false);}}
                className={`${activeSection === 'home' ? 'text-amber-500' : ''} px-3 py-2 text-sm font-medium text-left`}
              >
                Home
              </button>
              <button 
                onClick={() => {setActiveSection('hotels'); setMobileMenuOpen(false);}}
                className={`${activeSection === 'hotels' ? 'text-amber-500' : ''} px-3 py-2 text-sm font-medium text-left`}
              >
                Hostels
              </button>
              <button 
                onClick={() => {setActiveSection('guesthouses'); setMobileMenuOpen(false);}}
                className={`${activeSection === 'guesthouses' ? 'text-amber-500' : ''} px-3 py-2 text-sm font-medium text-left`}
              >
                Guest Houses
              </button>
              <button 
                onClick={() => {setActiveSection('experiences'); setMobileMenuOpen(false);}}
                className={`${activeSection === 'experiences' ? 'text-amber-500' : ''} px-3 py-2 text-sm font-medium text-left`}
              >
                Experiences
              </button>
              <button className="bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-medium mt-2 transition-colors shadow-md">
                Book Now
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <div className="pt-20 pb-16 md:pt-24 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-2xl shadow-xl">
            <div className={`absolute inset-0 ${darkMode ? 'bg-black/50' : 'bg-black/30'} z-10`}></div>
            <img 
              src="https://www.jainuniversity.ac.in/jain/theme/assets/images/contact/JGI-hostel.jpg" 
              alt="Luxury Hotel" 
              className="w-full h-[500px] object-cover"
            />
            <div className="absolute inset-0 z-20 flex flex-col justify-center items-center text-center px-4">
              <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4 text-white">
                Experience Unparalleled Hostel
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-white max-w-3xl">
                Discover our collection of the world's most exquisite hostels and guest houses, where every detail is crafted for perfection.
              </p>
              
              {/* Search Bar */}
              <div className={`w-full max-w-3xl p-1 rounded-full ${darkMode ? 'bg-gray-800/80' : 'bg-white/90'} shadow-lg`}>
                <div className="flex flex-col md:flex-row items-center">
                  <div className="flex-1 flex items-center px-4 py-3">
                    <MapPin className="h-5 w-5 text-amber-500 mr-2" />
                    <input 
                      type="text" 
                      placeholder="Destination" 
                      className={`flex-1 bg-transparent outline-none ${darkMode ? 'placeholder-gray-400' : 'placeholder-gray-500'}`}
                    />
                  </div>
                  <div className="flex-1 flex items-center px-4 py-3 border-t md:border-t-0 md:border-l border-gray-200 dark:border-gray-700">
                    <Calendar className="h-5 w-5 text-amber-500 mr-2" />
                    <input 
                      type="text" 
                      placeholder="Check-in / Check-out" 
                      className={`flex-1 bg-transparent outline-none ${darkMode ? 'placeholder-gray-400' : 'placeholder-gray-500'}`}
                    />
                  </div>
                  <div className="flex-1 flex items-center px-4 py-3 border-t md:border-t-0 md:border-l border-gray-200 dark:border-gray-700">
                    <Users className="h-5 w-5 text-amber-500 mr-2" />
                    <input 
                      type="text" 
                      placeholder="Guests" 
                      className={`flex-1 bg-transparent outline-none ${darkMode ? 'placeholder-gray-400' : 'placeholder-gray-500'}`}
                    />
                  </div>
                  <button className="bg-amber-500 hover:bg-amber-600 text-white p-3 rounded-full m-1 transition-colors">
                    <Search className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Promotional Ad Carousel */}
      <div className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden h-64">
          {ads.map((ad, index) => (
            <div 
              key={ad.id}
              ref={index === currentAdIndex ? adRef : null}
              className={`absolute inset-0 transition-opacity duration-1000 ${index === currentAdIndex ? 'opacity-100' : 'opacity-0'}`}
            >
              <div className="absolute inset-0 bg-black/40 z-10"></div>
              <img 
                src={ad.bgImage} 
                alt={ad.title} 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 z-20 flex flex-col justify-center items-start px-12">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-2">{ad.title}</h3>
                <p className="text-white mb-6 max-w-md">{ad.content}</p>
                <button className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-2 rounded-full font-medium transition-colors">
                  {ad.cta}
                </button>
              </div>
            </div>
          ))}
          <div className="absolute bottom-4 left-0 right-0 z-20 flex justify-center space-x-2">
            {ads.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentAdIndex(index)}
                className={`w-3 h-3 rounded-full ${index === currentAdIndex ? 'bg-amber-500' : 'bg-white/50'}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Unique Selling Points */}
      <div className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif font-bold mb-4">Why Choose Al-Saray?</h2>
            <p className="text-lg max-w-2xl mx-auto">
              We go beyond traditional hospitality to deliver truly exceptional experiences.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {uniqueFeatures.map((feature, index) => (
              <div 
                key={index} 
                className={`p-6 rounded-xl border ${darkMode ? 'border-gray-700 hover:bg-gray-800' : 'border-gray-200 hover:bg-gray-50'} transition-all hover:shadow-lg`}
              >
                <div className={`w-16 h-16 rounded-full ${darkMode ? 'bg-gray-700' : 'bg-gray-100'} flex items-center justify-center mb-4 mx-auto`}>
                  <div className="text-amber-500">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="text-xl font-serif font-bold mb-2 text-center">{feature.title}</h3>
                <p className={`text-center ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Featured Hotels Carousel */}
      <div className="py-12 bg-gray-100 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-3xl font-serif font-bold">Signature Properties</h2>
              <p className="mt-2">
                Our most exclusive hotels, hand-selected for their exceptional quality
              </p>
            </div>
            <div className="flex space-x-2">
              <button 
                onClick={() => scrollCarousel('left')}
                className="p-2 rounded-full bg-white dark:bg-gray-700 shadow-md hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
              <button 
                onClick={() => scrollCarousel('right')}
                className="p-2 rounded-full bg-white dark:bg-gray-700 shadow-md hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
              >
                <ArrowRight className="h-5 w-5" />
              </button>
            </div>
          </div>
          
          <div 
            ref={carouselRef}
            className="flex overflow-x-auto scrollbar-hide space-x-6 pb-6 -mx-4 px-4"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {hostels.map((hotel) => (
              <div 
                key={hotel.id} 
                className={`flex-none w-80 rounded-xl overflow-hidden shadow-lg transition-transform hover:scale-[1.02] ${darkMode ? 'bg-gray-700' : 'bg-white'}`}
                style={{ scrollSnapAlign: 'start' }}
              >
                <div className="relative h-64">
                  <img 
                    src={hotel.images[0]} 
                    alt={hotel.name} 
                    className="w-full h-full object-cover"
                  />
                  <button 
                    onClick={() => toggleFavorite(hotel.id)}
                    className={`absolute top-4 left-4 p-2 rounded-full ${favorites.includes(hotel.id) ? 'bg-amber-500 text-white' : darkMode ? 'bg-gray-800/90 text-white' : 'bg-white/90 text-gray-800'}`}
                  >
                    <Heart className={`h-5 w-5 ${favorites.includes(hotel.id) ? 'fill-current' : ''}`} />
                  </button>
                  <div className={`absolute top-4 right-4 px-3 py-1 rounded-full ${darkMode ? 'bg-gray-800/90' : 'bg-white/90'} flex items-center`}>
                    <Star className="h-4 w-4 text-amber-500 fill-amber-500 mr-1" />
                    <span className="text-sm font-medium">{hotel.rating}</span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-serif font-bold">{hotel.name}</h3>
                    <span className="text-amber-500 font-medium">{hotel.price}</span>
                  </div>
                  <div className="flex items-center text-gray-500 dark:text-gray-400 mb-4">
                    <MapPin className="h-4 w-4 mr-1" />
                    <span className="text-sm">{hotel.location}</span>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-6">
                    {hotel.amenities.slice(0, 3).map((amenity, index) => (
                      <span 
                        key={index} 
                        className={`text-xs px-2 py-1 rounded-full ${darkMode ? 'bg-gray-600 text-gray-200' : 'bg-gray-100 text-gray-700'}`}
                      >
                        {amenity}
                      </span>
                    ))}
                    {hotel.amenities.length > 3 && (
                      <span className={`text-xs px-2 py-1 rounded-full ${darkMode ? 'bg-gray-600 text-gray-200' : 'bg-gray-100 text-gray-700'}`}>
                        +{hotel.amenities.length - 3} more
                      </span>
                    )}
                  </div>
                  <button 
                    onClick={() => setSelectedHotel(hotel)}
                    className="w-full bg-amber-500 hover:bg-amber-600 text-white py-2 rounded-lg font-medium transition-colors flex items-center justify-center"
                  >
                    View Details <ChevronRight className="h-4 w-4 ml-1" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Interactive Map Section */}
      <div className="py-12 bg-gray-100 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
 
        <InteractiveHotelMap />
   
        </div>
      </div>

      {/* Footer */}
      <footer className={`py-12 ${darkMode ? 'bg-gray-800 text-gray-300' : 'bg-gray-900 text-gray-300'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <Hotel className="h-8 w-8 text-amber-500" />
                <span className="ml-2 text-xl font-serif font-bold text-white">Al-Saray<span className="text-amber-500">HMS</span></span>
              </div>
              <p className="text-sm">
                Redefining  hospitality with exceptional properties and unparalleled service worldwide.
              </p>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">Explore</h4>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-amber-400 transition-colors">Our Properties</a></li>
                <li><a href="#" className="hover:text-amber-400 transition-colors">Destinations</a></li>
                <li><a href="#" className="hover:text-amber-400 transition-colors">Special Offers</a></li>
                <li><a href="#" className="hover:text-amber-400 transition-colors">Loyalty Program</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">Company</h4>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-amber-400 transition-colors">About Us</a></li>
                <li><a href="#" className="hover:text-amber-400 transition-colors">Careers</a></li>
                <li><a href="#" className="hover:text-amber-400 transition-colors">Press</a></li>
                <li><a href="#" className="hover:text-amber-400 transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">Get in Touch</h4>
              <p className="text-sm mb-4">
                Have questions about booking or special requests? Our team is here to help.
              </p>{/*
              <button className="bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-medium transition-colors">
                Contact Us
              </button>*/}
            </div>
          </div>
          <div className="border-t border-gray-700 mt-12 pt-8 text-sm text-center">
            <p>© {new Date().getFullYear()} Al-SarayHMS. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

const HotelDetail = ({ hotel, onBack, darkMode, isFavorite, onToggleFavorite, onVirtualTour }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('overview');
   const [showContactPopup, setShowContactPopup] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    checkIn: '',
    checkOut: ''
  });

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % hotel.images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + hotel.images.length) % hotel.images.length);
  };

  // In your LuxuryHotelSystem component (or wherever you're triggering the booking)
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingData, setBookingData] = useState({
    checkIn: '',
    checkOut: '',
    adults: 2,
    children: 0,
    rooms: 1,
    specialRequests: ''
  });



const handleBookNow = () => {
    setShowBookingModal(true);
  };


 


  return (
    <div className={`min-h-screen ${darkMode ? 'dark bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'}`}>
      {/* Header */}
      <header className={`fixed w-full z-50 ${darkMode ? 'bg-gray-800/90 backdrop-blur' : 'bg-white/90 backdrop-blur'} shadow-sm`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            <button 
              onClick={onBack}
              className="flex items-center text-amber-500"
            >
              <ArrowLeft className="h-5 w-5 mr-1" />
              Back
            </button>
            <div className="flex items-center space-x-4">
              <button 
                onClick={() => onToggleFavorite(hotel.id)}
                className={`p-2 rounded-full ${isFavorite ? 'bg-amber-500 text-white' : darkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800'}`}
              >
                <Heart className={`h-5 w-5 ${isFavorite ? 'fill-current' : ''}`} />
              </button>
              <button className="p-2 rounded-full bg-gray-200 dark:bg-gray-700">
                <Share2 className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Image Gallery */}
          <div className="relative rounded-2xl overflow-hidden h-96 mb-8">
            <img 
              src={hotel.images[currentImageIndex]} 
              alt={hotel.name} 
              className="w-full h-full object-cover"
            />
            <div className={`absolute inset-0 ${darkMode ? 'bg-black/20' : 'bg-black/10'}`}></div>
            <button 
              onClick={prevImage}
              className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 dark:bg-gray-800/80 shadow-md hover:bg-white dark:hover:bg-gray-700 transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <button 
              onClick={nextImage}
              className="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 dark:bg-gray-800/80 shadow-md hover:bg-white dark:hover:bg-gray-700 transition-colors"
            >
              <ArrowRight className="h-5 w-5" />
            </button>
            <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
              {hotel.images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  className={`w-3 h-3 rounded-full ${index === currentImageIndex ? 'bg-amber-500' : 'bg-white/50'}`}
                />
              ))}
            </div>
          </div>

          {/* Hotel Info */}
          <div className="flex flex-col md:flex-row gap-8">
            <div className="md:w-2/3">
              <h1 className="text-3xl font-serif font-bold mb-2">{hotel.name}</h1>
              <div className="flex items-center text-gray-500 dark:text-gray-400 mb-6">
                <MapPin className="h-5 w-5 mr-1" />
                <span>{hotel.location}</span>
                <div className="flex items-center ml-4">
                  <Star className="h-5 w-5 text-amber-500 fill-amber-500 mr-1" />
                  <span className="font-medium">{hotel.rating} (24 reviews)</span>
                </div>
              </div>

              {/* Tabs */}
              <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
                <nav className="-mb-px flex space-x-8">
                  <button
                    onClick={() => setActiveTab('overview')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'overview' 
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400' 
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
                  >
                    Overview
                  </button>
                  <button
                    onClick={() => setActiveTab('amenities')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'amenities' 
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400' 
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
                  >
                    Amenities
                  </button>
                  <button
                    onClick={() => setActiveTab('reviews')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'reviews' 
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400' 
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
                  >
                    Reviews
                  </button>
                  <button
                    onClick={() => setActiveTab('location')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'location' 
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400' 
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
                  >
                    Location
                  </button>
                  <button
                    onClick={() => setActiveTab('policies')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'policies' 
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400' 
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
                  >
                    Policies
                  </button>
                </nav>
              </div>

              {/* Tab Content */}
              <div className="mb-8">
                {activeTab === 'overview' && (
                  <div>
                    <h3 className="text-xl font-serif font-bold mb-4">About {hotel.name}</h3>
                    <p className="mb-6">{hotel.description}</p>
                    <button 
                      onClick={onVirtualTour}
                      className="flex items-center text-amber-500 font-medium"
                    >
                      <Video className="h-5 w-5 mr-2" />
                      Take Virtual Tour
                    </button>
                  </div>
                )}
                
                {activeTab === 'amenities' && (
                  <div>
                    <h3 className="text-xl font-serif font-bold mb-4">Amenities & Services</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="flex items-center">
                        <Wifi className="h-5 w-5 text-amber-500 mr-2" />
                        <span>High-speed WiFi</span>
                      </div>
                      <div className="flex items-center">
                        <Droplets className="h-5 w-5 text-amber-500 mr-2" />
                        <span>Infinity Pool</span>
                      </div>
                      <div className="flex items-center">
                        <Utensils className="h-5 w-5 text-amber-500 mr-2" />
                        <span>24/7 Room Service</span>
                      </div>
                      <div className="flex items-center">
                        <Snowflake className="h-5 w-5 text-amber-500 mr-2" />
                        <span>Air Conditioning</span>
                      </div>
                      <div className="flex items-center">
                        <Tv className="h-5 w-5 text-amber-500 mr-2" />
                        <span>Smart TV</span>
                      </div>
                      <div className="flex items-center">
                        <Coffee className="h-5 w-5 text-amber-500 mr-2" />
                        <span>Premium Coffee</span>
                      </div>
                      <div className="flex items-center">
                        <Wine className="h-5 w-5 text-amber-500 mr-2" />
                        <span>Minibar</span>
                      </div>
                      <div className="flex items-center">
                        <ConciergeBell className="h-5 w-5 text-amber-500 mr-2" />
                        <span>Concierge Service</span>
                      </div>
                    </div>
                  </div>
                )}
                
                {activeTab === 'reviews' && (
                  <div>
                    <h3 className="text-xl font-serif font-bold mb-4">Guest Reviews</h3>
                    <div className="space-y-6">
                      {hotel.reviews.map((review, index) => (
                        <div key={index} className={`p-4 rounded-lg ${darkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
                          <div className="flex justify-between mb-2">
                            <span className="font-medium">{review.user}</span>
                            <div className="flex">
                              {[...Array(5)].map((_, i) => (
                                <Star 
                                  key={i} 
                                  className={`h-4 w-4 ${i < review.rating ? 'text-amber-500 fill-amber-500' : 'text-gray-400'}`} 
                                />
                              ))}
                            </div>
                          </div>
                          <p>{review.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {activeTab === 'location' && (
                  <div>
                    <h3 className="text-xl font-serif font-bold mb-4">Location & Nearby</h3>
                    <div className="mb-6">
                      <div className={`rounded-xl overflow-hidden h-64 ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                        <div className="relative h-full flex items-center justify-center">
                          <MapPin className="h-12 w-12 text-amber-500" />
                        </div>
                      </div>
                    </div>
                    <h4 className="font-medium mb-2">Nearby Attractions:</h4>
                    <ul className="space-y-2">
                      {hotel.nearby.map((item, index) => (
                        <li key={index} className="flex items-center">
                          <span className="text-amber-500 mr-2">{item.icon}</span>
                          <span>{item.name} ({item.distance})</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                
                {activeTab === 'policies' && (
                  <div>
                    <h3 className="text-xl font-serif font-bold mb-4">Hotel Policies</h3>
                    <div className="space-y-4">
                      <div>
                        <h4 className="font-medium">Cancellation Policy</h4>
                        <p>{hotel.policies.cancellation}</p>
                      </div>
                      <div>
                        <h4 className="font-medium">Check-In/Check-Out</h4>
                        <p>Check-in: {hotel.policies.checkIn}, Check-out: {hotel.policies.checkOut}</p>
                      </div>
                      <div>
                        <h4 className="font-medium">Pet Policy</h4>
                        <p>{hotel.policies.pets}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

             {/* Booking Modal */}
           {showBookingModal && (
        <BookingModal 
             hotel={hotel}
            darkMode={darkMode}
            showBookingModal={showBookingModal}
            setShowBookingModal={setShowBookingModal}
        />
        )}

            {/* Contact Popup */}
            {showContactPopup && (
            <ContactPopup 
                showContactPopup={showContactPopup}
                setShowContactPopup={setShowContactPopup}
                darkMode={darkMode}
            />
            )}
            

            {/* Booking Sidebar */}
            <div className="md:w-1/3">
              <div className={`sticky top-24 rounded-xl overflow-hidden shadow-lg ${darkMode ? 'bg-gray-800' : 'bg-white'} border ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                <div className="p-6">
                  <div className="flex justify-between items-center mb-6">
                    <h3 className="text-xl font-serif font-bold">Your Stay</h3>
                    <span className="text-amber-500 font-medium">{hotel.price}</span>
                  </div>
                  
                  <div className="space-y-4 mb-6">
                    <div>
                      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Dates</label>
                      <div className={`flex items-center px-4 py-3 rounded-lg border ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-300'}`}>
                        <Calendar className="h-5 w-5 text-amber-500 mr-2" />
                        <span>Apr 15 - Apr 20, 2024</span>
                      </div>
                    </div>
                    
                    <div>
                      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Guests</label>
                      <div className={`flex items-center px-4 py-3 rounded-lg border ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-300'}`}>
                        <Users className="h-5 w-5 text-amber-500 mr-2" />
                        <span>2 Adults, 1 Room</span>
                      </div>
                    </div>
                  </div>
              

                <button 
                    onClick={handleBookNow}
                    className="w-full bg-amber-500 hover:bg-amber-600 text-white py-3 rounded-lg font-medium transition-colors shadow-md mb-4"
                  >
                    Book Now
                  </button>
                  
                  <div className="text-center">
                    <button 
                           onClick={() => setShowContactPopup(true)}
                          className="flex-1 border border-amber-600 text-amber-600 hover:bg-amber-50 py-3 px-6 rounded-lg font-medium transition-colors flex items-center justify-center">
                          <Phone className="h-4 w-4 mr-2" />
                          Contact Hotel
                        </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};




export default HotelSystem;